import React from 'react';
import { useRouter } from 'next/navigation';
import CitySearch from '@/components/seo/search-area/CitySearch';
import { JobTitleContext } from '@/context/create-context';
import { Option } from '@/components/form/cascade-select/CascadeSelect';
import { NATION_WIDE } from '@/constants/city';
import { JOB_TITLE_PAGE_ROUTER_PATH } from '@/constants/router-path';

const JobTitleCitySearch = () => {
  const {
    jobTitle: { id: jobTitleId, province_city_data, location },
    isJobTitleCity,
  } = React.useContext(JobTitleContext);

  const router = useRouter();

  const handleSearch = (value: Option) => {
    const { id, pinyin } = value;
    if (
      !id ||
      id === location?.id ||
      (!isJobTitleCity && id === NATION_WIDE.id)
    )
      return;
    router.push(
      id === NATION_WIDE.id
        ? `${JOB_TITLE_PAGE_ROUTER_PATH}${jobTitleId}/`
        : `/${pinyin}/${jobTitleId}/`,
    );
  };

  return (
    <CitySearch
      cityValue={
        isJobTitleCity && location
          ? { id: location.id, name: location.name, pinyin: location.pinyin }
          : NATION_WIDE
      }
      existCities={[NATION_WIDE, ...province_city_data]}
      onSearch={handleSearch}
    />
  );
};

export default JobTitleCitySearch;
